if(typeof AI == "undefined") {
	AI = {};
}

(function (AI) {
	'use strict';

	var form = function() {
		this.form = {};
	};

	form.prototype = {

		sendUsFormID: '#sendUsFormID',
		sendYourselfFormID: '#sendYourselfFormID',
		enquiryFormID: '#enquiryFormID',
		submitFormID: '#submitFormID',
		requestFileFormID: '#requestFileFormID',

    	/**
    	 * [initialize description]
    	 * @return {[type]} [description]
    	 */
        init: function() {
        	if ($(this.sendUsFormID).length > 0) {
	        	this.validateForm(this.sendUsFormID);
			}
			if ($(this.sendYourselfFormID).length > 0) {
	        	this.validateForm(this.sendYourselfFormID);
			}
			if ($(this.enquiryFormID).length > 0) {
				this.validateForm(this.enquiryFormID);
			}
			if ($(this.requestFileFormID).length > 0) {
				this.validateForm(this.requestFileFormID);
			}
			if ($(this.submitFormID).length > 0) {
				this.initTownPicker();
				//this.loadTowns();
				//this.loadBuildingTypes();
				this.initUnitSwitcher();
				this.validateForm(this.submitFormID);
			}

			var self = this;
			$('#downloads, #contact_agent, #request_file, #shortlist-us, #shortlist-yourself').on('hidden.bs.modal', function () {
				self.clearForms();
			});
        },

        /**
         * [initTownPicker description]
         * @return {[type]} [description]
         */
        initTownPicker: function() {
	        $('#all').click(function() {
	            $('.input-append .selectpicker').selectpicker('selectAll');
	        });
	        $('#none').click(function() {
	            $('.input-append .selectpicker').selectpicker('deselectAll');
	        });
	    },

	    /**
	     * [enableFormSubmission description]
	     * @return {[type]} [description]
	     */
	    enableFormSubmission: function(form) {
	    	var self = this, $loader = $(form).find('.spinner-load');

			$loader.removeClass('hidden d-none');
			self.submitNewEnquiry(form).then(function(response) {
				$loader.addClass('hidden d-none');
    			if (response.status == 'success') {
    				alertify.success(response.message);
    				if (response.file_url !== undefined) {
    					$('#download-url').attr('href', response.file_url);
						$('#download-url').removeClass('hidden d-none');
	    			} else {
						$('#downloads, #contact_agent, #request_file, #shortlist-us, #shortlist-yourself').modal('hide');
						self.clearForms();
	    			}
    			} else {
					$(form).find('.invalid-form-error-message').html(response.message).removeClass('hidden d-none');
    			}
				}, function(response) {
					$loader.addClass('hidden d-none');
					var msg = response.message ? response.message : 'Please try again, otherwise contact us.';
					$(form).find('.invalid-form-error-message').html(msg).removeClass('hidden d-none');
				});
	    },

	    /**
	     * [submitNewEnquiry description]
	     * @return {[type]} [description]
	     */
	    submitNewEnquiry: function(form) {
	    	var self = this,
	    		serializedForm = $(form).serialize();

			$(form).find('.valid-form-message').html('').addClass('hidden d-none');
			$(form).find('.invalid-form-error-message').html('').addClass('hidden d-none');

			var href = $(form).attr('action');

			if (href === undefined) {
				href = APP.site_url + '/enquire';
			}

			return $.ajax({
				url: href,
				data: serializedForm,
				dataType: 'json',
				type: 'POST',
				headers: {
					'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
				}
			});
		},

	    /**
	     * [validateForm description]
	     * @return {[type]} [description]
	     */
	    validateForm: function(form) {
	    	var self = this;

	    	$(form).find('.valid-form-message').addClass('hidden d-none').html('');
    		$(form).find('.invalid-form-error-message').addClass('hidden d-none').html('');

	    	$(form).parsley({
	            successClass: "has-success",
	            errorClass: "has-error",
	            classHandler: function (el) {
	                return el.$element.closest('.form-block'); //working
	            },
	            errorsWrapper: "<span class='help-block'></span>",
            	errorTemplate: "<span></span>"
	        });
	    	$(form).parsley().on('field:validated', function(formInstance) {
    			var ok = $('.parsley-error').length === 0;
    			$('.invalid-form-error-message')
    				.html(ok ? '' : 'Please fill in the required fields!')
    				.removeClass('hidden d-none')
      				.toggleClass('filled', !ok);
    			if (!ok)
      				formInstance.validationResult = false;
  			})
  			.on('form:submit', function() {
  				self.enableFormSubmission(form);
    			return false;
  			});
	    },

	    /**
	     * [loadTowns description]
	     * @return {[type]} [description]
	     */
	    loadTowns: function() {
	    	$(".town-data").select2({
  				data: APP.towns
			});
	    },

	    /**
	     * [loadTowns description]
	     * @return {[type]} [description]
	     */
	    loadBuildingTypes: function() {
            console.log(APP.buildingTypes);
	    	$(".buildingTypes-data").select2({
  				data: APP.buildingTypes
			});
	    },

	    /**
	     * [initUnitSwitcher description]
	     * @return {[type]} [description]
	     */
	    initUnitSwitcher: function() {
	    	$("#unit_sqm").on("click", function() {
	    		$('#size_unit').val('sqm'); 
	    		$('#unit_sqft').removeClass('active');
	    	});
			$("#unit_sqft").on("click", function() {
				$('#size_unit').val('sqft'); 
				$('#unit_sqm').removeClass('active');
			});
		},

		/**
	     * [clearForms description]
	     * @return {[type]} [description]
	     */
		clearForms: function() {
			var $form = $(
				this.sendUsFormID + ',' +
				this.sendYourselfFormID + ',' +
				this.enquiryFormID + ',' +
				this.submitFormID + ',' +
				this.requestFileFormID
			);
			if ($(this.sendUsFormID).length > 0) {
				$(this.sendUsFormID).parsley().reset();
			}
			if ($(this.sendYourselfFormID).length > 0) {
				$(this.sendYourselfFormID).parsley().reset();
			}
			if ($(this.enquiryFormID).length > 0) {
				$(this.enquiryFormID).parsley().reset();
			}
			if ($(this.submitFormID).length > 0) {
				$(this.submitFormID).parsley().reset();
			}
			if ($(this.requestFileFormID).length > 0) {
				$(this.requestFileFormID).parsley().reset();
			}

			grecaptcha.reset();

			$form[0].reset();
			$form.find('textarea').val('');
			$form.find('select').val('');
			$form.find('.selectpicker').selectpicker('refresh');
			$form.find('#download_url').val('');
			$form.find('#file_id').val('');
			$form.find('.invalid-form-error-message').html('').addClass('hidden d-none');
			$form.find('.valid-form-message').html('').addClass('hidden d-none');
		}
	};

	AI.form = new form();

})(AI);

AI.form.init();


// WEBPACK FOOTER //
// ./resources/assets/js/ai/form.js